/**
 * Glassmorphism Design Tokens
 * Shared visual language for the redesigned Safar Glimpse UI
 */

const GlassmorphismTokens = {
  // Glass backgrounds with varying transparency
  glass: {
    light: 'rgba(255, 255, 255, 0.12)',
    medium: 'rgba(255, 255, 255, 0.18)',
    heavy: 'rgba(255, 255, 255, 0.25)',
    // For dark-themed modals (Screens 5-6)
    darkLight: 'rgba(30, 41, 59, 0.85)',
    darkMedium: 'rgba(30, 41, 59, 0.92)',
    darkHeavy: 'rgba(15, 23, 42, 0.95)',
  },

  // Backdrop blur values
  blur: {
    sm: 'blur(8px)',
    md: 'blur(16px)',
    lg: 'blur(20px)',
    xl: 'blur(32px)',
  },

  // Primary CTA gradient (blue) replacing Airbnb-red
  gradient: {
    blueCTA: 'linear-gradient(135deg, #4285F4 0%, #1A73E8 100%)',
    blueCTAHover: 'linear-gradient(135deg, #1A73E8 0%, #1557B0 100%)',
    // Purple/violet secondary gradient
    purple: 'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
    purpleLight: 'linear-gradient(135deg, #A78BFA 0%, #8B5CF6 100%)',
    // Scenic overlay gradient (for background images)
    scenicOverlay: 'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.5) 100%)',
    // Progress bar
    progress: 'linear-gradient(90deg, #4285F4 0%, #1A73E8 100%)',
  },

  // Dark overlay/surface colors for modals
  dark: {
    overlay: 'rgba(15, 23, 42, 0.85)',
    surface: 'rgba(30, 41, 59, 0.95)',
    surfaceLight: 'rgba(51, 65, 85, 0.9)',
    card: 'rgba(51, 65, 85, 0.7)',
    border: 'rgba(148, 163, 184, 0.2)',
    text: '#F1F5F9',
    textSecondary: '#94A3B8',
    textMuted: '#64748B',
  },

  // Glass border styles
  border: {
    light: '1px solid rgba(255, 255, 255, 0.2)',
    medium: '1px solid rgba(255, 255, 255, 0.3)',
    heavy: '1px solid rgba(255, 255, 255, 0.4)',
    dark: '1px solid rgba(148, 163, 184, 0.2)',
  },

  // Glass shadows
  shadow: {
    glass: '0 8px 32px rgba(0, 0, 0, 0.12)',
    glassLg: '0 16px 48px rgba(0, 0, 0, 0.2)',
    dark: '0 8px 32px rgba(0, 0, 0, 0.4)',
    blueCTA: '0 4px 16px rgba(66, 133, 244, 0.35)',
    blueCTAHover: '0 8px 24px rgba(66, 133, 244, 0.45)',
  },

  // Scenic background image (default)
  scenicBackground: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=1920&q=80',

  // Time-of-day color coding for timeline
  timeColors: {
    morning: { dot: '#F59E0B', bg: 'rgba(245, 158, 11, 0.15)', text: '#D97706' },
    afternoon: { dot: '#3B82F6', bg: 'rgba(59, 130, 246, 0.15)', text: '#2563EB' },
    evening: { dot: '#8B5CF6', bg: 'rgba(139, 92, 246, 0.15)', text: '#7C3AED' },
  },
};

export default GlassmorphismTokens;
